import { openOpportunityPage } from "@utils/navigation.util";
import { IOpportunityTagResponse } from "@interfaces/responses.interface";
import { TagWrapper } from "./TagWrapper";
import { TagLabel } from "@ui/Content";
import { View } from "@ui/View";

interface Props {
  data: IOpportunityTagResponse;
  isDisabled?: boolean;
  onAdd?: (tag: IOpportunityTagResponse) => void;
  onRemove?: (tag: IOpportunityTagResponse) => void;
  withPlusIcon?: boolean;
  iconOnly?: boolean;
}

export function OpportunityTag({
  data,
  isDisabled = false,
  onAdd,
  onRemove,
  withPlusIcon,
  iconOnly,
}: Props) {
  return (
    <TagWrapper
      data={data}
      isDisabled={isDisabled}
      onRemove={onRemove}
      onRedirect={() => openOpportunityPage(data.object.id)}
      withPlusIcon={withPlusIcon}
      onAdd={onAdd}
    >
      <span
        aria-hidden
        className="m-1 h-2.5 w-2.5 flex-shrink-0 rotate-45 rounded-[1px]"
        style={{ backgroundColor: data.object.stage?.color }}
      />

      <View.Condition if={!iconOnly}>
        <TagLabel className="mr-1">{data.object.title}</TagLabel>
      </View.Condition>
    </TagWrapper>
  );
}
